import styled from 'styled-components'
import { backgroundOrange, darkGrey, lightGrey, surface2 } from '@/theme/colors'
import { shellGutter } from '@/theme/layout'
import { media, radii } from '@/theme/tokens'

export const BoardHeader = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
`

export const DragOverlayCard = styled.div`
	transform: rotate(3deg);
	cursor: grabbing;
`

export const BoardContainer = styled.div`
	background: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 24px 0 0 0;

	${media.phone} {
		padding: 16px 0 0 0;
	}
`

export const ScrollableColumnsWrapper = styled.div`
	overflow-x: auto;
	overflow-y: hidden;
	flex: 1;
	min-height: 0;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		height: 8px;
	}

	&::-webkit-scrollbar-track {
		background: ${surface2};
		border-radius: ${radii.round};
	}

	&::-webkit-scrollbar-thumb {
		background: ${lightGrey};
		border-radius: ${radii.round};

		&:hover {
			background: ${darkGrey};
		}
	}

	/* Firefox */
	scrollbar-width: thin;
	scrollbar-color: ${lightGrey} ${surface2};
`

export const ColumnsContainer = styled.div`
	display: flex;
	gap: 16px;
	align-items: flex-start;
	height: 100%;
	/* The shell's gutters, shared with the toolbar above, so the first column starts under the day count. */
	padding: 0 ${shellGutter.wide} 16px;

	${media.bentoCollapse} {
		padding: 0 ${shellGutter.narrow} 16px;
	}

	${media.phone} {
		gap: 12px;
	}

	/* Add spacing after the last column using pseudo-element */
	/* This prevents right padding from being clipped by overflow-x */
	&::after {
		content: '';
		display: block;
		min-width: 16px;
	}
`

